var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinResidencialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.438,9.176c-0.07,0.141-0.188,0.211-0.352,0.211h-1.652v7.488c0,0.259-0.129,0.387-0.387,0.387h-4.5 c-0.234,0-0.352-0.128-0.352-0.387v-4.887h-2.25v4.887c0,0.259-0.129,0.387-0.387,0.387h-4.5c-0.258,0-0.387-0.128-0.387-0.387 V9.387H1.09c-0.164,0-0.281-0.082-0.352-0.246C0.668,9,0.691,8.872,0.809,8.754L8.156,0.95l0.07-0.07 c0.515-0.422,1.055-0.434,1.617-0.035l0.07,0.07l7.453,7.84C17.461,8.848,17.484,8.989,17.438,9.176z M8.684,11.25V1.477H8.648 L1.934,8.614h1.125c0.258,0,0.387,0.129,0.387,0.387v7.488h3.727v-4.852c0-0.258,0.128-0.387,0.387-0.387H8.684z M16.207,8.649 L9.422,1.512v9.738h1.125c0.258,0,0.387,0.129,0.387,0.387v4.852h3.762V9c0-0.234,0.129-0.352,0.387-0.352H16.207z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinResidencialIcon);
export default __webpack_public_path__ + "static/media/zeppelin-residencial-icon.6892796a.svg";
export { ForwardRef as ReactComponent };